import Vue from 'vue'
import Vuex from 'vuex'

import { tune } from './tune.module';
import { auth } from './auth.module';

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    tune,
    auth
  }
})
